import { Component, OnInit, TemplateRef } from '@angular/core';
import { Documenttitle } from './documenttitle';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BsModalRef, ModalOptions, BsModalService } from 'ngx-bootstrap';
import { DocumenttitleService } from './documenttitle.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { LocalService } from '../../local.service';

@Component({
  selector: 'app-documenttitle',
  templateUrl: './documenttitle.component.html',
  styleUrls: ['./documenttitle.component.css']
})
export class DocumenttitleComponent implements OnInit {
  sendMenuId: number;
  sendPageName: string = 'Document Title';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;

  documenttitleForm: FormGroup;
  documenttitles: Documenttitle[] = [];
  documenttitlesactive: Documenttitle[] = [];
  documenttitle: Documenttitle;
  deleteResult: boolean
  postresult: boolean
  putDResult: boolean
  documenttitleModalRef: BsModalRef;
  operation: string;
  userid: number;
  documenttitleid: number;
  submitted = false;
  active: number;
  unamePattern: string;
  confmsg: string;
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true
  }
  showall: boolean = true;
  showallstatus: boolean = false;
  key: string = 'documenttitle'; //set default
  reverse: boolean = false;

  constructor(
    private documenttitleservice: DocumenttitleService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService, private dialogService: DialogService,
    private localService: LocalService) {
    //code to get relavent menu id      
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      localStorage.setItem('DocumentTitle_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('DocumentTitle_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('DocumentTitle_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('DocumentTitle_action');
    }

  }

  //get f() { return this.userForm.controls; }
  ngOnInit() {
    this.checkIsMenuMapped();
    this.documenttitleForm = this.formBuilder.group({
      documenttitleid: [''],
      documenttitle: ['', [Validators.required]],
      active: ['']
    });
    this.searchText = '';
    this.getAll();
    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizeddocumenttitle");
    let data = arrays.find(ob => ob['name'] === 'Document Title');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizeddocumenttitle","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizeddocumenttitle",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.documenttitleModalRef.hide();
  }

  getAll() {
    this.documenttitles = [];
    this.documenttitlesactive = [];
    this.documenttitleservice.Get().subscribe(res => {
      this.documenttitles = res;
      if (this.showallstatus == true) {
        this.documenttitles.forEach(data => {
          if (data.active == 1) {
            this.documenttitlesactive.push(data);
          }
        });
        this.documenttitles = [];
        this.documenttitles = this.documenttitlesactive;
      }
    }, error => { this.toastr.error('Error while getting data'); });

  }

  getactiveinactive(showallp) {
    this.documenttitlesactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.documenttitles.forEach(data => {
        if (data.active == 1) {
          this.documenttitlesactive.push(data);
        }
      });
      this.documenttitles = [];
      this.documenttitles = this.documenttitlesactive;
    }
    else {
      this.showall = true;
      this.documenttitles = [];
      this.getAll();
    }
  }

  get g() { return this.documenttitleForm.controls; }

  Post(documenttitle: Documenttitle) {

    this.submitted = true;
    // stop here if form is invalid
    //if (this.documenttitleForm.invalid) {
    //  console.log(this.g);
    //  console.log(this.documenttitleForm.errors);
    //}

    if ((documenttitle.documenttitle.trim() == undefined) || (documenttitle.documenttitle.trim() == '')) {
      this.toastr.error('Document Title should not be empty');
      return;
    }

    var msg = null;
    documenttitle.documenttitle = documenttitle.documenttitle.trim();
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");

    if (this.operation == 'add') {

      documenttitle.createdby = this.userid;
      msg = "Record Added Successfully";
      this.documenttitleservice.Post(documenttitle).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.documenttitleModalRef.hide();
              this.getAll();
              this.toastr.success('Data added successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }
    else if (this.operation = 'update') {
      this.submitShow = true;
      documenttitle.modifiedby = this.userid;
      msg = "Record updated successfully";
      this.documenttitleservice.Put(documenttitle).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            ;
            if (res.body != 0) {
              this.documenttitleModalRef.hide();
              this.getAll();
              this.toastr.success('Data updated successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }

    //console.log(this.documenttitleForm.value);


  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.documenttitleForm.value.active = 1;
    } else {
      this.documenttitleForm.value.active = 0
    }
  }

  OpenConfirmTemplate(documenttitle, template: TemplateRef<any>) {
    if (documenttitle.active == 0) {
      this.confmsg = "activate";
    }
    else
      this.confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.documenttitle = documenttitle;

          this.Delete();

        }

      });

  }

  Delete() {
    var msg;
    if (this.documenttitle.active == 0) {
      this.documenttitle.active = 1
      msg = "Record activated successfully"
    }
    else {
      this.documenttitle.active = 0;
      msg = "Record deactivated successfully"
    }
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");

    this.documenttitle.modifiedby = this.userid;
    this.documenttitleservice.Delete(this.documenttitle).subscribe(res => {
      this.toastr.success(msg);
      this.getAll();
    },
      error => { this.deleteResult = false })

  }

  hidePopup() {
    this.documenttitleModalRef.hide();
  }

  openDocumenttitleModal(template: TemplateRef<any>, type, documenttitle?: Documenttitle) {
    this.operation = type

    if (type == 'update') {
      this.documenttitleForm.controls['documenttitleid'].setValue(documenttitle.documenttitleid);
      this.documenttitleForm.controls['documenttitle'].setValue(documenttitle.documenttitle);
      this.documenttitleForm.controls['active'].setValue(documenttitle.active);
      this.documenttitle = documenttitle;
    }
    if (type == 'add') {
      this.documenttitleForm.controls['documenttitleid'].setValue(0);
      this.documenttitleForm.controls['documenttitle'].setValue('');
      this.documenttitleForm.controls['active'].setValue(1);
    }
    this.documenttitleModalRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");

  }

}
